import React from "react";

function CommunityPage() {
  return <div>CommunityPage</div>;
}

export default CommunityPage;
